import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { WidgetSize } from '@wix/wix-chatbot-common/browser';

type WidgetState = Readonly<{
  size: WidgetSize;
  expanded: boolean;
  mobileView?: boolean; // means widget container(iframe) stretched to full screen size(works based on `only screen and (max-width: 760px)`)
  caraActiveInOtherTab: boolean;
}>;

const initialState: WidgetState = {
  size: WidgetSize.Default,
  expanded: true,
  caraActiveInOtherTab: false,
};

export const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    setSize: (state, action: PayloadAction<WidgetSize>) => {
      state.size = action.payload;
    },
    setExpanded: (state, action: PayloadAction<boolean>) => {
      state.expanded = action.payload;
    },
    setMobileView: (state, action: PayloadAction<boolean>) => {
      state.mobileView = action.payload;
    },
    setCaraActiveInOtherTab: (state, action: PayloadAction<boolean>) => {
      state.caraActiveInOtherTab = action.payload;
    },
  },
});

export const widgetActions = widgetSlice.actions;
